// extracted by mini-css-extract-plugin
export var quantityInput = "_fc-0";